import { Box, FormControl, FormHelperText, FormLabel, Grid, MenuItem, Select } from "@mui/material";
import React from "react";

const names = [
	'Oliver Hansen',
	'Van Henry',
	'April Tucker',
	'Ralph Hubbard',
	'Omar Alexander',
	'Carlos Abbott',
	'Miriam Wagner',
	'Bradley Wilkerson',
	'Virginia Andrews',
	'Kelly Snyder',
];

const Selects = ({age, handleAgeChange}) => {
	const [personName, setPersonName] = React.useState([]);
	
	const handleChange = (event) => {
		const {
			target: {value},
		} = event;
		setPersonName(
			// On autofill, we get a stringified value.
			typeof value === 'string' ? value.split(',') : value,
		);
	};
	
	return (
		<Box>
			<Box>
				<h3>Standard</h3>
				<Grid container spacing={3}>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Select')}</FormLabel>
							<Select
								variant="standard"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}} disabled>
							<FormLabel>Disabled</FormLabel>
							<Select
								labelId="demo-simple-select-disabled-label"
								id="demo-simple-select-disabled"
								label="Age"
								defaultValue={10}
								variant={'standard'}
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Read only</FormLabel>
							<Select
								variant={"standard"}
								labelId="demo-simple-select-readonly-label"
								id="demo-simple-select-readonly"
								defaultValue={10}
								onChange={handleAgeChange}
								inputProps={{readOnly: true}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required>
							<FormLabel>{('Required')}</FormLabel>
							<Select
								variant="standard"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required error={true}>
							<FormLabel>{('Error')}</FormLabel>
							<Select
								variant="standard"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>
								{'Απαιτείται'}
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Placeholder')}</FormLabel>
							<Select
								variant="standard"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								displayEmpty
								label="Age"
								renderValue={(selected) => {
									if (selected.length === 0) {
										return <em>Placeholder</em>;
									}
									return age
								}}
							>
								<MenuItem disabled value=""><em>Placeholder</em></MenuItem>
								<MenuItem value=""><em>None</em></MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Multiple</FormLabel>
							<Select
								labelId="demo-multiple-name-label"
								id="demo-multiple-name"
								multiple
								value={personName}
								onChange={handleChange}
								variant={"standard"}
							>
								{names.map((name) => (
									<MenuItem
										key={name}
										value={name}
									>
										{name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</Box>
			<Box>
				<h3>Outlined</h3>
				<Grid container spacing={3}>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Select')}</FormLabel>
							<Select
								variant="outlined"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}} disabled>
							<FormLabel>Disabled</FormLabel>
							<Select
								id="demo-simple-select-disabled"
								defaultValue={10}
								variant="outlined"
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Read only</FormLabel>
							<Select
								variant="outlined"
								labelId="demo-simple-select-readonly-label"
								id="demo-simple-select-readonly"
								defaultValue={10}
								onChange={handleAgeChange}
								inputProps={{readOnly: true}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required>
							<FormLabel>{('Required')}</FormLabel>
							<Select
								variant="outlined"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required error={true}>
							<FormLabel>{('Error')}</FormLabel>
							<Select
								variant="outlined"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>
								{'Απαιτείται'}
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Placeholder')}</FormLabel>
							<Select
								variant="outlined"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								displayEmpty
								renderValue={(selected) => {
									if (selected.length === 0) {
										return <em>Placeholder</em>;
									}
									return age
								}}
							>
								<MenuItem disabled value=""><em>Placeholder</em></MenuItem>
								<MenuItem value=""><em>None</em></MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Multiple</FormLabel>
							<Select
								labelId="demo-multiple-name-label"
								id="demo-multiple-name"
								multiple
								value={personName}
								onChange={handleChange}
								variant="outlined"
							>
								{names.map((name) => (
									<MenuItem
										key={name}
										value={name}
									>
										{name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</Box>
			<Box>
				<h3>Filled</h3>
				<Grid container spacing={3}>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Select')}</FormLabel>
							<Select
								variant="filled"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}} disabled>
							<FormLabel>Disabled</FormLabel>
							<Select
								labelId="demo-simple-select-disabled-label"
								id="demo-simple-select-disabled"
								label="Age"
								defaultValue={10}
								variant="filled"
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Read only</FormLabel>
							<Select
								variant="filled"
								labelId="demo-simple-select-readonly-label"
								id="demo-simple-select-readonly"
								defaultValue={10}
								onChange={handleAgeChange}
								inputProps={{readOnly: true}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required>
							<FormLabel>{('Required')}</FormLabel>
							<Select
								variant="filled"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}} required error={true}>
							<FormLabel>{('Error')}</FormLabel>
							<Select
								variant="filled"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>
								{'Απαιτείται'}
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: '120px'}}>
							<FormLabel>{('Placeholder')}</FormLabel>
							<Select
								variant="filled"
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								displayEmpty
								label="Age"
								renderValue={(selected) => {
									if (selected.length === 0) {
										return <em>Placeholder</em>;
									}
									return age
								}}
							>
								<MenuItem disabled value=""><em>Placeholder</em></MenuItem>
								<MenuItem value=""><em>None</em></MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl sx={{minWidth: 120}}>
							<FormLabel>Multiple</FormLabel>
							<Select
								labelId="demo-multiple-name-label"
								id="demo-multiple-name"
								multiple
								value={personName}
								onChange={handleChange}
								variant="filled"
							>
								{names.map((name) => (
									<MenuItem
										key={name}
										value={name}
									>
										{name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</Box>
		</Box>
	)
}


{/*TODO::ALL SELECT FIELDS
				<Grid item>
					<div>
						<FormControl variant="standard" sx={{m: 1, minWidth: 120}}>
							<InputLabel id="demo-simple-select-standard-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={age}
								onChange={handleAgeChange}
								label="Age"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
						<FormControl variant="filled" sx={{m: 1, minWidth: 120}}>
							<InputLabel id="demo-simple-select-filled-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-filled-label"
								id="demo-simple-select-filled"
								value={age}
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
						</FormControl>
					</div>
				</Grid>
				<Grid item>
					<div>
						<FormControl sx={{m: 1, minWidth: 120}}>
							<InputLabel id="demo-simple-select-helper-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-helper-label"
								id="demo-simple-select-helper"
								value={age}
								label="Age"
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>With label + helper text</FormHelperText>
						</FormControl>
						<FormControl sx={{m: 1, minWidth: 120}}>
							<Select
								value={age}
								onChange={handleAgeChange}
								displayEmpty
								inputProps={{'aria-label': 'Without label'}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>Without label</FormHelperText>
						</FormControl>
					</div>
				</Grid>
				<Grid item>
					<FormControl sx={{m: 1, minWidth: 120}} size="small">
						<InputLabel id="demo-select-small-label">Age</InputLabel>
						<Select
							labelId="demo-select-small-label"
							id="demo-select-small"
							value={age}
							label="Age"
							onChange={handleAgeChange}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							<MenuItem value={10}>Ten</MenuItem>
							<MenuItem value={20}>Twenty</MenuItem>
							<MenuItem value={30}>Thirty</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item>
					<div>
						<FormControl sx={{m: 1, minWidth: 120}} disabled>
							<InputLabel id="demo-simple-select-disabled-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-disabled-label"
								id="demo-simple-select-disabled"
								value={age}
								label="Age"
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>Disabled</FormHelperText>
						</FormControl>
						<FormControl sx={{m: 1, minWidth: 120}} error>
							<InputLabel id="demo-simple-select-error-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-error-label"
								id="demo-simple-select-error"
								value={age}
								label="Age"
								onChange={handleAgeChange}
								renderValue={(value) => `⚠️  - ${value}`}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>Error</FormHelperText>
						</FormControl>
						<FormControl sx={{m: 1, minWidth: 120}}>
							<InputLabel id="demo-simple-select-readonly-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-readonly-label"
								id="demo-simple-select-readonly"
								value={age}
								label="Age"
								onChange={handleAgeChange}
								inputProps={{readOnly: true}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>Read only</FormHelperText>
						</FormControl>
						<FormControl required sx={{m: 1, minWidth: 120}}>
							<InputLabel id="demo-simple-select-required-label">Age</InputLabel>
							<Select
								labelId="demo-simple-select-required-label"
								id="demo-simple-select-required"
								value={age}
								label="Age *"
								onChange={handleAgeChange}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value={10}>Ten</MenuItem>
								<MenuItem value={20}>Twenty</MenuItem>
								<MenuItem value={30}>Thirty</MenuItem>
							</Select>
							<FormHelperText>Required</FormHelperText>
						</FormControl>
					</div>
				</Grid>*/}

export default Selects;